<template>
    <div class="overlay">
        <div class="wrapper">
            <div class="lds-ripple">
                <div></div>
                <div></div>
            </div>
            <div v-if="msg" class="text" v-text="msg"></div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "AppLoader",
    props: {
      msg: {
        type: String
      }
    }
  }
</script>

<style scoped>
    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: white !important;
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        /*position: absolute;*/
        /*top: calc(50% - 40px);*/
        /*left: calc(50% - 40px);*/
    }

    .lds-ripple {
        display: inline-block;
        position: relative;
        width: 80px;
        height: 80px;
    }

    .lds-ripple div {
        position: absolute;
        border: 4px solid #3177BA;
        opacity: 1;
        border-radius: 50%;
        animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
    }

    .lds-ripple div:nth-child(2) {
        animation-delay: -0.5s;
    }

    @keyframes lds-ripple {
        0% {
            top: 36px;
            left: 36px;
            width: 0;
            height: 0;
            opacity: 1;
        }
        100% {
            top: 0px;
            left: 0px;
            width: 72px;
            height: 72px;
            opacity: 0;
        }
    }
</style>
